import React from "react";
import {Card, Col, Row} from "react-bootstrap";
import {FaBoxOpen, FaCheckCircle, FaClock, FaRupeeSign} from "react-icons/fa";

const formatRevenue = (value) => {
    if (value === null || value === undefined || value === "") return "—";
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return "—";
    return new Intl.NumberFormat("en-IN", {style: "currency", currency: "INR", maximumFractionDigits: 0}).format(numericValue);
};

const SummaryCards = ({data}) => {
    const metrics = [
        {label: "Total sales", value: formatRevenue(data?.total_revenue), note: "Revenue from your store", icon: <FaRupeeSign />, tone: ""},
        {label: "Total orders", value: data?.total_order_count ?? "—", note: "Orders placed with you", icon: <FaBoxOpen />, tone: "metric-blue"},
        {label: "Completed", value: data?.delivered_count ?? "—", note: "Successfully delivered", icon: <FaCheckCircle />, tone: "metric-green"},
        {label: "Accepted by you", value: data?.vendor_accepted_count ?? "—", note: "Orders you have accepted", icon: <FaClock />, tone: "metric-purple"},
    ];

    return (
        <Row className="g-3 mb-4">
            {metrics.map((metric) => (
                <Col xs={12} sm={6} xl={3} key={metric.label}>
                    <Card className="metric-card">
                        <Card.Body>
                            <div className="metric-head">
                                <span className="metric-label">{metric.label}</span>
                                <span className={`metric-icon ${metric.tone}`}>{metric.icon}</span>
                            </div>
                            <div className="metric-value">{metric.value}</div>
                            <div className="metric-note">{metric.note}</div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default SummaryCards;
